import axios from 'axios';

const backendBase = process.env.REACT_APP_API_URL;

const adminClient = axios.create({
  baseURL: backendBase,
  headers: {
    'Content-Type': 'application/json'
  }
});

adminClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('admin_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

adminClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const message = error.response?.data?.message
      || error.response?.data?.detail
      || error.response?.data?.error
      || error.message
      || 'Something went wrong';

    if (error.response?.status === 403 && /blocked/i.test(message)) {
      localStorage.removeItem('admin_token');
      localStorage.removeItem('admin_profile');
      if (typeof window !== 'undefined' && window.location.pathname !== '/admin/login') {
        window.location.href = '/admin/login';
      }
    }

    return Promise.reject({
      message,
      data: error.response?.data || null
    });
  }
);

export const adminApi = {
  login: (email, password) => adminClient.post('/admin/login', { email, password }),
  getMe: () => adminClient.get('/admin/me'),
  getDashboard: () => adminClient.get('/admin/dashboard'),
  getOwners: () => adminClient.get('/admin/owners'),
  createOwner: (payload) => adminClient.post('/admin/owners', payload),
  toggleOwnerStatus: (userId) => adminClient.patch(`/admin/owners/${userId}/status`),
  upsertOwnerSubscription: (userId, payload) => adminClient.put(`/admin/owners/${userId}/subscription`, payload),
  cancelOwnerSubscription: (userId) => adminClient.patch(`/admin/owners/${userId}/subscription/cancel`),
  getSubAdmins: () => adminClient.get('/admin/sub-admins'),
  createSubAdmin: (payload) => adminClient.post('/admin/sub-admins', payload),
  updateSubAdminOwners: (subAdminId, ownerIds) => adminClient.put(`/admin/sub-admins/${subAdminId}/owners`, { ownerIds }),
  toggleSubAdminStatus: (subAdminId) => adminClient.patch(`/admin/sub-admins/${subAdminId}/status`),
  getPgs: () => adminClient.get('/admin/pgs'),
  getTenants: () => adminClient.get('/admin/tenants')
};
